import { toUTCDateString } from './date'
import { digitsOnlyZip } from './zip-code'
import { normalizeCityInput } from './city'

export const getDonateNearYouParams = formData => {
  const params = new URLSearchParams()

  if (formData.distance) params.append('distance', formData.distance)
  if (formData.date) params.append('date', toUTCDateString(formData.date))
  if (formData.procedure_type_id)
    params.append('procedure_type_id', formData.procedure_type_id)
  if (formData.address) {
    const addressToForward = {
      latitude: formData.address.latitude,
      longitude: formData.address.longitude,
      formatted_address: formData.address.formatted_address,
    }
    params.append('address', JSON.stringify(addressToForward))
  }
  return params
}

export const getSearchByDonorCentersParams = formData => {
  const params = new URLSearchParams()
  if (formData.donor_center_id)
    params.append('donor_center_id', String(formData.donor_center_id))
  if (formData.procedure_type_id)
    params.append('procedure_type_id', formData.procedure_type_id)
  if (formData.date) params.append('date', toUTCDateString(formData.date))
  return params
}

export const parseSearchByDonorCentersParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  return {
    donor_center_id: params.donor_center_id || '',
    procedure_type_id: params.procedure_type_id || '',
    date: params.date || null,
  }
}

export const parseDonateNearYouParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  const parsedFormData = {
    address: params.address ? JSON.parse(params.address) : {},
    procedure_type_id: params.procedure_type_id || '',
    date: params.date || null,
    distance: params.distance
      ? params.distance === 'any'
        ? 'any'
        : Number(params.distance)
      : 5,
  }
  return parsedFormData
}

export const getScheduledDonationsParams = formData => {
  const params = new URLSearchParams()
  if (formData.operation_id)
    params.append('operation_id', formData.operation_id)
  if (formData.operation_type)
    params.append('operation_type', formData.operation_type)
  if (formData.procedure_type_id)
    params.append('procedure_type_id', formData.procedure_type_id)
  if (formData.date) params.append('date', toUTCDateString(formData.date))
  if (formData.latitude) params.append('latitude', formData.address?.latitude)
  if (formData.longitude)
    params.append('longitude', formData.address?.longitude)
  return params
}

export const parseScheduledDonationsParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  const parsedFormData = {
    date: params.date || null,
    latitude: params.latitude || null,
    longitude: params.longitude || null,
    operation_id: params.operation_id || '',
    operation_type: params.operation_type || '',
    procedure_type_id: params.procedure_type_id || '',
  }

  return parsedFormData
}

export const routeToRedirectUrl = redirectUrl => {
  if (redirectUrl) {
    // Always use replace to completely replace the URL in browser history
    const isAbsolute = /^https?:\/\//i.test(redirectUrl)
    if (isAbsolute) {
      window.location.replace(redirectUrl)
    } else {
      // For relative URLs, construct the full URL and replace
      const fullUrl = new URL(redirectUrl, window.location.origin).href
      window.location.replace(fullUrl)
    }
  }
}

export const getGuestConfirmAppointmentParams = formData => {
  const params = new URLSearchParams()
  if (formData.date) params.append('date', toUTCDateString(formData.date))
  if (formData.slot_id) params.append('slot_id', formData.slot_id)
  if (formData.start_time) params.append('start_time', formData.start_time)
  if (formData.operation_id)
    params.append('operation_id', formData.operation_id)
  if (formData.operation_type)
    params.append('operation_type', formData.operation_type)
  return params
}

export const parseGuestConfirmAppointmentParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  const parsedFormData = {
    date: params.date || '',
    slot_id: params.slot_id || '',
    start_time: params.start_time || '',
    operation_id: params.operation_id || '',
    operation_type: params.operation_type || '',
  }
  return parsedFormData
}

const parseBoolQuery = (value, defaultVal) => {
  if (value === 'false') return false
  if (value === 'true') return true
  return defaultVal
}

export const getSearchByZipCodeParams = formData => {
  const params = new URLSearchParams()
  const zip5 = digitsOnlyZip(formData.zip_code).slice(0, 5)
  if (zip5) params.append('zip_code', zip5)
  if (formData.start_date)
    params.append('start_date', toUTCDateString(formData.start_date))
  if (formData.end_date)
    params.append('end_date', toUTCDateString(formData.end_date))
  if (formData.procedure_type_id)
    params.append('procedure_type_id', formData.procedure_type_id)
  params.append(
    'include_mobile_drives',
    formData.include_mobile_drives === false ? 'false' : 'true'
  )
  params.append(
    'include_donor_centers',
    formData.include_donor_centers === false ? 'false' : 'true'
  )
  return params
}

export const parseSearchByZipCodeParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  return {
    zip_code: digitsOnlyZip(params.zip_code || '').slice(0, 5),
    start_date: params.start_date || null,
    end_date: params.end_date || null,
    procedure_type_id: params.procedure_type_id || '',
    include_mobile_drives: parseBoolQuery(params.include_mobile_drives, true),
    include_donor_centers: parseBoolQuery(params.include_donor_centers, true),
  }
}

export const getSearchByCityParams = formData => {
  const params = new URLSearchParams()
  const city = normalizeCityInput(formData.city)
  if (city) params.append('city', city)
  if (formData.start_date)
    params.append('start_date', toUTCDateString(formData.start_date))
  if (formData.end_date)
    params.append('end_date', toUTCDateString(formData.end_date))
  if (formData.procedure_type_id)
    params.append('procedure_type_id', formData.procedure_type_id)
  params.append(
    'include_mobile_drives',
    formData.include_mobile_drives === false ? 'false' : 'true'
  )
  params.append(
    'include_donor_centers',
    formData.include_donor_centers === false ? 'false' : 'true'
  )
  return params
}

export const parseSearchByCityParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  return {
    city: normalizeCityInput(params.city || ''),
    start_date: params.start_date || null,
    end_date: params.end_date || null,
    procedure_type_id: params.procedure_type_id || '',
    include_mobile_drives: parseBoolQuery(params.include_mobile_drives, true),
    include_donor_centers: parseBoolQuery(params.include_donor_centers, true),
  }
}

export const getSearchBySponsorParams = formData => {
  const params = new URLSearchParams()
  if (formData.account_id)
    params.append('account_id', String(formData.account_id))
  if (formData.start_date)
    params.append('start_date', toUTCDateString(formData.start_date))
  if (formData.end_date)
    params.append('end_date', toUTCDateString(formData.end_date))
  if (formData.procedure_type_id)
    params.append('procedure_type_id', formData.procedure_type_id)
  return params
}

export const parseSearchBySponsorParams = searchParams => {
  const params = Object.fromEntries(searchParams)
  return {
    account_id: params.account_id || '',
    start_date: params.start_date || null,
    end_date: params.end_date || null,
    procedure_type_id: params.procedure_type_id || '',
  }
}

export function isValidDriveId(driveId) {
  const trimmed = String(driveId ?? '').trim()
  return /^\d+$/.test(trimmed) && trimmed.length > 0
}

const PRIVATE_DRIVE_SCHEDULE_PARAM_KEYS = [
  'operation_id',
  'operation_type',
  'date',
  'procedure_type_id',
]

/** Build URLSearchParams for /schedule-donation from private-drive-search API data. */
export function scheduleParamsFromPrivateDriveResponse(data) {
  const sq = data?.schedule_query
  const params = new URLSearchParams()
  if (!sq || typeof sq !== 'object') return params
  for (const key of PRIVATE_DRIVE_SCHEDULE_PARAM_KEYS) {
    const value = sq[key]
    if (value != null && String(value) !== '') {
      params.append(key, String(value))
    }
  }
  return params
}
